<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
    >
      <el-tab-pane
        label="当日成交汇总"
        name="transactionSummary"
      >
        <transactionInquiry />
      </el-tab-pane>
      <el-tab-pane
        label="当日成交明细"
        name="transactionDetails"
      >
        <transactionDetails />
      </el-tab-pane>
      <el-tab-pane
        label="历史成交汇总"
        name="historicalTransactioninquiry"
      >
        <historicalTransactioninquiry />
      </el-tab-pane>
      <el-tab-pane
        label="历史成交明细"
        name="historicalTransactionDetails"
      >
        <historicalTransactionDetails />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import transactionInquiry from './transaction-inquiry'
import transactionDetails from './transaction-details'
import historicalTransactioninquiry from './historical-transaction-inquiry'
import historicalTransactionDetails from './historical-transaction-details'
export default {
  name: 'Index',
  components: {
    transactionInquiry,
    transactionDetails,
    historicalTransactioninquiry,
    historicalTransactionDetails
  },
  data () {
    return {
      activeName: 'transactionSummary',
    }
  }
}

</script>
